(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3735],{

/***/ 37889:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/[templateId]",
      function () {
        return __webpack_require__(32858);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _templateId_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./src/components/site/SiteLayout/index.tsx + 24 modules
var SiteLayout = __webpack_require__(96895);
// EXTERNAL MODULE: ./src/components/site/GridBackground/index.tsx
var GridBackground = __webpack_require__(93726);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./src/components/business/PlatformPreview/PreviewActions/index.tsx
var PreviewActions = __webpack_require__(24309);
// EXTERNAL MODULE: ./src/components/business/ChannelPreview/index.tsx
var ChannelPreview = __webpack_require__(24023);
;// CONCATENATED MODULE: ./src/modules/Site/Template/index.tsx










var Template = function(param) {
    var template = param.template;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("web"), platform = ref[0], setPlatform = ref[1];
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var previewRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        smallerScreen && setPlatform("mobile");
    }, [
        platform,
        smallerScreen
    ]);
    var handleTplApply = function() {
        if (!template.code) {
            return;
        }
        router.push({
            pathname: "https://app-cny.howxm.com" + constants/* Signup */.Al,
            query: {
                templateCode: template.code
            }
        });
    };
    var handleRefresh = function() {
        var ref;
        (ref = previewRef.current) === null || ref === void 0 ? void 0 : ref.refresh();
    };
    if (!template) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        size: 1200,
        p: 0,
        className: "pt-[123px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            justify: "center",
            spacing: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 0,
                    className: "px-[26px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 1,
                            weight: 900,
                            className: "text-[32px] leading-[48px] mb-[8px] sm:mb-[12px] sm:text-[56px] sm:leading-[81px] text-center",
                            children: template.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 3,
                            weight: 400,
                            className: "text-[16px] leading-[24px] sm:text-[18px] sm:leading-[25px] text-center mb-[24px] sm:mb-[36px]",
                            children: template.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                    className: "sm:pb-[56px] pb-[48px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        w: 210,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            fullWidth: true,
                            variant: "default",
                            size: "lg",
                            sx: function(theme) {
                                return {
                                    fontSize: theme.fontSizes.sm
                                };
                            },
                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                name: "sparkles"
                            }),
                            onClick: handleTplApply,
                            children: "选用模板"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    align: "center",
                    pos: "relative",
                    className: "mx-[12px] sm:mx-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                            h: "656px",
                            w: "100%",
                            children: platform === "web" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelPreview/* default */.Z, {
                                previewRef: previewRef,
                                channel: "web",
                                template: template
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelPreview/* default */.Z, {
                                previewRef: previewRef,
                                channel: "mobileApp",
                                template: template
                            })
                        }),
                        !smallerScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewActions/* default */.Z, {
                            platformChangeable: true,
                            widgetType: template === null || template === void 0 ? void 0 : template.widget.type,
                            onPlatformClick: setPlatform,
                            onRefresh: handleRefresh,
                            className: "top-0  ".concat(platform === "web" ? "right-[-60px]" : "right-[350px]")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Site_Template = (Template);

// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/assets/images/site/footer-bg.jpg
var footer_bg = __webpack_require__(8733);
// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/pages/templates/[templateId]/index.tsx










var TemplateDetailPage = function(param) {
    var template = param.template;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            template.title,
                            "模板 - 浩客HowXM模板中心 - 应用内调研、评价、通知模板 - NPS 调研模板 - 评价反馈模板"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: "body {\n              min-width: 0 !important;\n            }"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridBackground/* default */.Z, {
                children: [
                    !!template && /*#__PURE__*/ (0,jsx_runtime.jsx)(Site_Template, {
                        template: template
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: "pt-[159px]",
                        sx: {
                            background: "url('".concat(footer_bg/* default.src */.Z.src, "') no-repeat center -30px / 1064px 770px")
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* GoToSignup */.yc, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: "mx-[53px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    mt: 72,
                    mb: 48
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* Footer */.$_, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _templateId_ = (TemplateDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2525,3703,8329,1958,4476,7094,1404,3226,9774,2888,179], function() { return __webpack_exec__(37889); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);